import { h, render, Fragment } from 'preact'
import styled, { keyframes } from 'styled-components'
import { colors } from '../style'

import { HiCheck, HiOutlineCog } from 'react-icons/hi'
import { AiOutlineCloudUpload } from 'react-icons/ai'

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const StatusWrapper = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${(props) => props.color};
  border-radius: 100%;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.8);

  svg {
    animation-name: ${(props) => (props.animate ? rotate : 'none')};
    animation-duration: 4s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
`

const isComplete = (value) => value === true || value === 100

const hasIncompleteOriginUpload = (data) => {
  if (data?.presets?.length) {
    const transcodeDone = data.presets.every((p) => isComplete(p.converting_progress))
    const uploadDone = data.presets.every((p) => isComplete(p.upload_progress))
    return transcodeDone && !uploadDone
  }

  return data?.upload_progress !== undefined && !isComplete(data.upload_progress)
}

export const resolveStatus = (data, override) => {
  if (override) {
    return override
  }

  if (data?.ready) {
    return 'ready'
  }

  if (hasIncompleteOriginUpload(data)) {
    return 'uploading'
  }

  if (data?.source_uploaded) {
    return 'converting'
  }

  return 'uploading'
}

export const Status = ({ data, override }) => {
  let status = resolveStatus(data, override)

  let animate = false,
    color,
    Icon
  switch (status) {
    case 'uploading':
      color = colors.blue
      Icon = AiOutlineCloudUpload
      break
    case 'converting':
      color = colors.purple
      Icon = HiOutlineCog
      animate = true
      break
    default:
      // Ready
      color = colors.green
      Icon = HiCheck
      break
  }
  return (
    <StatusWrapper color={color} animate={animate}>
      <Icon size={24} />
    </StatusWrapper>
  )
}
